var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCompleted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.667 2.453L6.06 10.067 3.233 7.24l.94-.94L6.06 8.187l6.667-6.667.94.933zm-1.474 3.36c.087.38.14.78.14 1.187A5.332 5.332 0 017 12.333 5.332 5.332 0 011.667 7 5.332 5.332 0 017 1.667a5.28 5.28 0 012.853.833l.96-.96A6.6 6.6 0 007 .333 6.67 6.67 0 00.333 7 6.67 6.67 0 007 13.667 6.67 6.67 0 0013.667 7c0-.793-.147-1.553-.4-2.26l-1.074 1.073z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCompleted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/completed.42faa593e61b2b4ff70117fa70df50d8.svg";